<section class="relative h-96 sm:h-120 md:h-160 pb-10 bg-contain bg-center bg-no-repeat transition-all duration-1000" 
    [ngStyle]="{'background-image': 'url(' + currentImage + ')'}">

    <div class="relative flex flex-col h-full">
        <div class="md:mt-[420px] w-[90%] rounded-t-lg m-auto z-10 right-0">
                
            <ul
                class="flex mt-16 justify-start md:justify-center -mb-px text-sm p-4 font-medium text-center bg-white rounded-t-lg w-full max-w-2xl overflow-x-auto"
                id="default-styled-tab"
                role="tablist"
            > 
                <li class=" me-2 ">
                    <button
                        class="inline-block text-black px-5 py-2 hover:bg-primary-100 hover:text-primary-500 rounded-md uppercase transition transition-duration: 500ms [&.active]:text-primary-500 [&.active]:bg-primary-100"
                        id="fights-tab"
                        [class.active]="view.selectedTab === 'flight'"
                        (click)="selectTab('flight')"
                        type="button"
                        role="tab"
                        aria-controls="flights"
                        aria-selected="true"
                    >
                    <!-- <mat-icon role="img" class="mat-icon notranslate fuse-vertical-navigation-item-icon mat-icon-no-color ng-star-inserted" aria-hidden="true" ng-reflect-svg-icon="mat_outline:directions_boat" data-mat-icon-type="svg" data-mat-icon-name="directions_boat" data-mat-icon-namespace="mat_outline"><svg viewBox="0 0 24 24" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M13 3v1h-2V3h2m-1 7.11l5.38 1.77 2.39.78-1.12 3.97c-.54-.3-.94-.71-1.14-.94L16 13.96l-1.51 1.72c-.34.4-1.28 1.32-2.49 1.32s-2.15-.92-2.49-1.32L8 13.96l-1.51 1.72c-.2.23-.6.63-1.14.93l-1.13-3.96 2.4-.79L12 10.11M15 1H9v3H6c-1.1 0-2 .9-2 2v4.62l-1.29.42c-.26.08-.48.26-.6.5s-.15.52-.06.78L3.95 19H4c1.6 0 3.02-.88 4-2 .98 1.12 2.4 2 4 2s3.02-.88 4-2c.98 1.12 2.4 2 4 2h.05l1.89-6.68c.08-.26.06-.54-.06-.78s-.34-.42-.6-.5L20 10.62V6c0-1.1-.9-2-2-2h-3V1zM6 9.97V6h12v3.97L12 8 6 9.97zm10 9.71c-1.22.85-2.61 1.28-4 1.28s-2.78-.43-4-1.28C6.78 20.53 5.39 21 4 21H2v2h2c1.38 0 2.74-.35 4-.99 1.26.64 2.63.97 4 .97s2.74-.32 4-.97c1.26.65 2.62.99 4 .99h2v-2h-2c-1.39 0-2.78-.47-4-1.32z"></path></svg></mat-icon> -->
                        Flights
                    </button>
                </li>
                <!-- <li class="me-2">
                    <button
                        class="inline-block text-black px-5 py-2 rounded-md hover:text-primary-500 hover:bg-primary-100 uppercase transition transition-duration: 500ms [&.active]:text-primary-500 [&.active]:bg-primary-100"
                        id="hotels-tab"
                        [class.active]="view.selectedTab === 'hotel'"
                        (click)="selectTab('hotel')"
                        type="button"
                        role="tab"
                        aria-controls="hotels"
                        aria-selected="view.selectedTab === 'hotel'"
                    >
                        Hotels
                    </button>
                </li> -->
                <li class="me-2">
                    <button
                        class="inline-block text-black px-5 py-2 rounded-md hover:text-primary-500 hover:bg-primary-100 uppercase transition transition-duration: 500ms [&.active]:text-primary-500 [&.active]:bg-primary-100"
                        id="Packages-tab"
                        [class.active]="view.selectedTab === 'package'"
                        (click)="selectTab('package')"
                        type="button"
                        role="tab"
                        aria-controls="packages"
                        aria-selected="view.selectedTab === 'package'"
                        [disabled]="false"
                    >
                        Packages
                    </button>
                </li>
                <li class="me-2">
                    <button
                        class="inline-block px-5 py-2 rounded-md hover:text-primary-500 uppercase text-hint"
                        [matTooltip]="'Coming Soon!'"
                        id="cars-tab"
                        [class.active]="view.selectedTab === 'car'"
                        (click)="selectTab('car')"
                        type="button"
                        role="tab"
                        aria-controls="cars"
                        aria-selected="view.selectedTab === 'car'"
                        [disabled]="true"
                    >
                        Cars
                    </button>
                </li>
                <!-- <li class="me-2">
                    <button
                        class="inline-block px-5 py-2 rounded-md hover:text-primary-500 uppercase text-hint"
                        [matTooltip]="'Coming Soon!'"
                        id="transfers-tab"
                        [class.active]="view.selectedTab === 'transfer'"
                        (click)="selectTab('transfer')"
                        type="button"
                        role="tab"
                        aria-controls="transfers"
                        aria-selected="view.selectedTab === 'transfer'"
                        [disabled]="true"
                    >
                        Transfers
                    </button>
                </li> -->
                <li class="me-2">
                    <button
                        class="inline-block px-5 py-2 rounded-md hover:text-primary-500 uppercase text-hint"
                        [matTooltip]="'Coming Soon!'"
                        id="transfers-tab"
                        [class.active]="view.selectedTab === 'cruises'"
                        (click)="selectTab('transfer')"
                        type="button"
                        role="tab"
                        aria-controls="transfers"
                        aria-selected="view.selectedTab === 'transfer'"
                        [disabled]="true"
                    >
                        Cruises
                    </button>
                </li>
                <!-- <li class="me-2">
                    <button class="inline-block px-5 py-2 rounded-md hover:text-gray-600 hover:bg-gray-100 text-white hover:text-black  uppercase" id="activities-tab" [class.active]="view.selectedTab === 'activities'" (click)="selectTab('activities')" type="button" role="tab" aria-controls="activities" aria-selected="view.selectedTab === 'activities'">Activities</button>
                </li>
                <li class="me-2">
                    <button class="inline-block px-5 py-2 rounded-md hover:text-gray-600 hover:bg-gray-100 text-white hover:text-black  uppercase" id="cruises-tab" [class.active]="view.selectedTab === 'cruises'" (click)="selectTab('cruises')" type="button" role="tab" aria-controls="cruises" aria-selected="view.selectedTab === 'cruises'">Cruises</button>
                </li> -->
            </ul>
            <div id="default-styled-tab-content" class="bg-white shadow-2xl rounded-b-xl md:rounded-tr-xl">
                @if (view.selectedTab === 'flight') {
                <div class="md:rounded-lg">
                    <search-widget
                        [panel]="{ type: 'flight' }"
                        (tripChange)="tripChanged($event)"
                        (searchChange)="searchChanged($event)"
                    ></search-widget>
                </div>
                } @if (view.selectedTab === 'hotel') {
                <div class="md:rounded-lg">
                    <search-widget
                        [panel]="{ type: 'stay' }"
                        (tripChange)="tripChanged($event)"
                        (searchChange)="searchChanged($event)"
                    ></search-widget>
                    <!-- <stay-list *ngIf="view.search && view.trip" [options]="view.search" [trip]="view.trip" [cacheMode]="view.cacheMode" (resultChange)="resultChanged()"></stay-list> -->
                </div>
                } @if (view.selectedTab === 'package') {
                <div class="md:rounded-lg">
                    <search-widget
                        [panel]="{ type: 'package' }"
                        (tripChange)="tripChanged($event)"
                        (searchChange)="searchChanged($event)"
                    ></search-widget>
                </div>
                } @if (view.selectedTab === 'car') {
                <div class="md:rounded-lg">
                    <search-widget
                        [panel]="{ type: 'car' }"
                        (tripChange)="tripChanged($event)"
                        (searchChange)="searchChanged($event)"
                    ></search-widget>
                </div>
                } @if (view.selectedTab === 'transfer') {
                <div class="md:rounded-lg">
                    <search-widget
                        [panel]="{ type: 'transfer' }"
                        (tripChange)="tripChanged($event)"
                        (searchChange)="searchChanged($event)"
                    ></search-widget>
                </div>
                } @if (view.selectedTab === 'activity') {
                <div class="md:rounded-lg">
                    <search-widget
                        [panel]="{ type: 'activity' }"
                        (tripChange)="tripChanged($event)"
                        (searchChange)="searchChanged($event)"
                    ></search-widget>
                </div>
                } @if (view.selectedTab === 'cruise') {
                <div class="md:rounded-lg">
                    <search-widget
                        [panel]="{ type: 'cruise' }"
                        (tripChange)="tripChanged($event)"
                        (searchChange)="searchChanged($event)"
                    ></search-widget>
                </div>
                }
            </div>
        </div>
    </div>
</section>